<template>
  <ag-modal-container
    title="Causes de rebut supprimées"
    width="900px"
    @close="back"
  >
    <div
      v-if="!loadingData && !rejectionCauseList.length"
      class="text-center title mt-5"
    >
      Aucun élément
    </div>

    <rejection-cause-list
      v-else
      :value="rejectionCauseList"
      :selected.sync="selectedRejectionCauseList"
      :loading="loadingData"
      light
    />

    <template v-slot:footer>
      <v-spacer />
      <ag-confirm-dialog
        title="Confirmation"
        :message="restoreMessage"
        cancel-label="Annuler"
        confirm-label="Restaurer"
        validation-btn-color="accent"
        @confirm="restoreSelected"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            :loading="loadingRestore"
            :disabled="!selectedRejectionCauseList.length || loadingRestore"
            color="accent"
            class="ml-5"
            v-bind="attrs"
            v-on="on"
            v-text="'Restaurer'"
          />
        </template>
      </ag-confirm-dialog>
    </template>
  </ag-modal-container>
</template>

<script>
import { mapActions } from 'vuex'
import Repositories from 'src/repositories'

import AgModalContainer from 'src/components/common/AgModalContainer'
import AgConfirmDialog from 'src/components/common/AgConfirmDialog'
import RejectionCauseList from '../components/RejectionCauseList'

export default {
  name: 'RejectionCauseRestoreContainer',
  components: {
    AgModalContainer,
    AgConfirmDialog,
    RejectionCauseList,
  },
  data () {
    return {
      rejectionCauseList: [],
      selectedRejectionCauseList: [],
      loadingData: false,
      loadingRestore: false,
    }
  },
  computed: {
    restoreMessage () {
      const count = this.selectedRejectionCauseList.length
      return `Souhaitez-vous restaurer ${count} cause(s) de rebut`
    },
  },
  watch: {
    $route: {
      immediate: true,
      handler ({ name }) {
        if (name === 'RejectionCauseRestore') {
          this.fetchData()
        }
      },
    },
  },
  methods: {
    ...mapActions('ui', {
      showSuccessNotification: 'showSuccessNotification',
      showErrorNotification: 'showErrorNotification',
    }),
    back () {
      this.$router.back()
    },
    async fetchData () {
      this.loadingData = true
      this.rejectionCauseList = await Repositories.rejectionCause.getList({ archived: true })
      this.loadingData = false
    },
    async restoreSelected () {
      try {
        this.loadingRestore = true
        const count = this.selectedRejectionCauseList.length
        await Repositories.rejectionCause.restore(
          this.selectedRejectionCauseList.map(select => select._id),
        )

        this.selectedRejectionCauseList = []
        this.fetchData()

        this.showSuccessNotification(`Vous avez restoré ${count} cause(s) de rebut`)
      }
      catch (error) {
        this.showErrorNotification(Repositories.parseErrorMessage(error))
      }
      finally {
        this.loadingRestore = false
      }
    },
  },
}
</script>
